export default function () {
    return {
        data:{},
        dataDefault: {
            id: '',
            descricao: '',
            id_banco: '',
            status: 'A',
            campo_chave: '',
            campo_exibicao: '',
            query: '',
            tag: '', 
            master:'S',
            multitenancy:'N'   
        },
        disableForm: false,
        dataList:[],        
        pagination:{},
        selectLookup:{}
    }
  }
  